const specializedModals = {
    namespaced: true,
    state: () => ({
        isSaladModalOpen: false,
        saladProduct: null,
        saladSelectedSize: null,
        isPastaModalOpen: false,
        pastaProduct: null,
        pastaSelectedSize: null
    }),
    mutations: {
        OPEN_SALAD_MODAL(state, { product, selectedSize }) {
            state.isSaladModalOpen = true;
            state.saladProduct = product;
            state.saladSelectedSize = selectedSize;
        },
        CLOSE_SALAD_MODAL(state) {
            state.isSaladModalOpen = false;
            state.saladProduct = null;
            state.saladSelectedSize = null;
        },
        OPEN_PASTA_MODAL(state, { product, selectedSize }) {
            state.isPastaModalOpen = true;
            state.pastaProduct = product;
            state.pastaSelectedSize = selectedSize;
        },
        CLOSE_PASTA_MODAL(state) {
            state.isPastaModalOpen = false;
            state.pastaProduct = null;
            state.pastaSelectedSize = null;
        }
    },
    actions: {
        openSaladModal({ commit }, { product, selectedSize }) {
            commit('OPEN_SALAD_MODAL', { product, selectedSize });
        },
        closeSaladModal({ commit }) {
            commit('CLOSE_SALAD_MODAL');
        },
        openPastaModal({ commit }, { product, selectedSize }) {
            commit('OPEN_PASTA_MODAL', { product, selectedSize });
        },
        closePastaModal({ commit }) {
            commit('CLOSE_PASTA_MODAL');
        }
    },
    getters: {
        isSaladModalOpen: (state) => state.isSaladModalOpen,
        saladProduct: (state) => state.saladProduct,
        saladSelectedSize: (state) => state.saladSelectedSize,
        isPastaModalOpen: (state) => state.isPastaModalOpen,
        pastaProduct: (state) => state.pastaProduct,
        pastaSelectedSize: (state) => state.pastaSelectedSize
    }
};
export default specializedModals;
